import moment from 'moment';


export const MONTH_LIST = [
    {monthNo: 1, month: 'January', noOfDays: 31},
    {monthNo: 2, month: 'February', noOfDays: 28},
    {monthNo: 3, month: 'March', noOfDays: 31},
    {monthNo: 4, month: 'April', noOfDays: 30},
    {monthNo: 5, month: 'May', noOfDays: 31},
    {monthNo: 6, month: 'June', noOfDays: 30},
    {monthNo: 7, month: 'July', noOfDays: 31},
    {monthNo: 8, month: 'August', noOfDays: 31},
    {monthNo: 9, month: 'September', noOfDays: 30},
    {monthNo: 10, month: 'October', noOfDays: 31},
    {monthNo: 11, month: 'November', noOfDays: 30},
    {monthNo: 12, month: 'December', noOfDays: 31},
]

export const WEEK_DAYS = [
    'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
]

export const MONTH_DAYS = [
    '1st', '2nd', '3rd', '4th', '5th', '6th', '7th', '8th', '9th', '10th',
    '11th', '12th', '13th', '14th', '15th', '16th', '17th', '18th', '19th', '20th',
    '21st', '22nd', '23rd', '24th', '25th', '26th', '27th', '28th', '29th', '30th', '31st'
]

export const RESET_CUSTOM_DATE = 1
export const RESET_HIRE_DATE = 2
export const RESET_MONTH_DATE = 3
export const RESET_WEEK_DAY = 4

// PTO request status
export const WAITING_FOR_APPROVAL = 1
export const CANCELED = 2
export const APPROVED = 3
export const DENIED = 4
export const PTO_REQUEST_STATUS = [
    "", "Waiting for Approval", "Canceled", "Approved", "Denied"
];
export const PTO_REQUEST_STATUS_LIST = [
    {value: 0, status: "All"},
    {value: 1, status: "Waiting for Approval"},
    {value: 2, status: "Canceled"},
    {value: 3, status: "Approved"},
    {value: 4, status: "Denied"}
];

export const TIMEOFF = "Time off";
export const HOLIDAY = "Holiday";
export const BLACKOUT = "Blackout";
export const BIRTHDAY = "Birthday";
export const MAX_BALANCE = 9999;

export const DOES_NOT_ALLOW_NEGATIVE = 0;
export const ALLOW_NEGATIVE_WITH_CARRY_OVER = 1;
export const ALLOW_NEGATIVE_WITHOUT_CARRY_OVER = 2;

export const UNLIMITED_PTO = 9999;

export const convertTimeTo12HourFormat = (time, defaultTime="09:00") => {
    let splitedTime = defaultTime.split(':');
    if (time) {
        splitedTime = time.split(':');
    }
    
    let hr = splitedTime[0] ? Number(splitedTime[0]) : 9;
    let mn = Number(splitedTime[1]) || 0;
    let amPm = 'AM'; 

    if (hr >= 12) {
        hr -= 12;
        amPm = 'PM';
    } 
    hr = hr === 0 ? 12 : (hr < 0) ? 9 : hr;

    return `${`0${hr}`.slice(-2)}:${`0${mn}`.slice(-2)} ${amPm}`;
}


// Get date falls on nth week day of the month e.g: 4th Monday of October
export const getMonthlyWeekDay = (n, d, m, y) => {
    let targetDay, curDay = 0, i = 1, lastTargetDay;
    while(curDay < n && i <= 31) {
        targetDay = moment(`${m}-${i++}-${y}}`, "MM-DD-YYYY");
        if(targetDay.weekday() === d) {
            curDay++;
            lastTargetDay = moment(targetDay);
        }
    }
    if(curDay === n){
        return targetDay;
    } else {
        // n = last
        if (n === 5) {
            return lastTargetDay;
        }
        return false;
    }
};



// WEBPACK FOOTER //
// ./src/components/pto/Constants.js